import { createContext } from "react";

const dealerContext = createContext();

export default dealerContext;
